import { Popup } from "react-leaflet";
import Marker from "./Marker";
import { styled } from "@mui/material";

const PopupStyled = styled(Popup)({
  "& .leaflet-popup-content-wrapper": {
    borderRadius: "8px 8px 0 0",
  },
  "& .leaflet-popup-content": {
    width: "20px !important",
    margin: "0px",
  },
  "& .leaflet-popup-tip-container": {
    width: "20px",
    height: "14px",
    marginLeft: "-10px",
  },
  "& .leaflet-popup-tip": {
    width: "18px",
    height: "18px",
  },
  "& .remove-btn": {
    width: "100%",
    textAlign: "center",
    cursor: "pointer",
  },
});

const AnalysisMarker = ({
  position,
  onPositionChange,
  onDelete,
  isViewOnly,
}) => {
  const handleDelete = (e) => {
    e.stopPropagation();
    onDelete?.();
  };

  const isRemovable = typeof onDelete === "function" && !isViewOnly;

  return (
    <Marker
      position={position}
      setPosition={onPositionChange}
      isDraggable={!isViewOnly}
    >
      {isRemovable && (
        <PopupStyled
          offset={{ x: 0, y: -20 }}
          closeOnEscapeKey
          keepInView
          closeButton={false}
        >
          <button className="btn-unstyled remove-btn" onClick={handleDelete}>
            x
          </button>
        </PopupStyled>
      )}
    </Marker>
  );
};

export default AnalysisMarker;
